/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Speakerphone = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.5 21.6667V19.9333L13.2854 18.0094C12.8736 19.412 11.5424 20.4167 10 20.4167C8.13777 20.4167 6.58333 18.952 6.58333 17.091C6.58333 16.801 6.62158 16.5196 6.69326 16.2515L3.5 15.4V16.3333H2V15V9.66667V8.33333H3.5V9.26667L20.5 4.73333V3H22V4.33333V5.88575V18.7809V20.3333V21.6667H20.5ZM3.5 10.8191V13.8476L20.5 18.3809V6.28575L3.5 10.8191ZM8.14263 16.638C8.10384 16.7829 8.08333 16.9346 8.08333 17.091C8.08333 18.0749 8.91671 18.9167 10 18.9167C10.8812 18.9167 11.597 18.3597 11.8334 17.6223L8.14263 16.638Z"
                        fill={color}
                    />
                </svg>
        );
    };
